module.exports = __webpack_public_path__ + "img/10.2d3aa922.png";